import apiClient from '../apiClient'

export const fetchCategories = async (outlet_id: number) => {
  const { data } = await apiClient.get(`/api/category?outlet_id=${outlet_id}`)
  return data
}
